module.exports = __webpack_public_path__ + "static/media/referee2.32c0fb39.png";